function EnrolleeAddress() {
    "use strict";
    this.__type = 'EnrolleeAddress:www.veritracks.com';
    this.Id = -1;

    this.AdditionalInfo = '';
    this.AddressTypeId = -1;
    this.City = '';
    this.Country = '';
    this.EnrolleeId = -1;
    this.IsActive = true;
    this.Latitude = 0.00;
    this.Longitude = 0.00;
    this.PositionMatchesGeocode = null;
    this.Notes = '';
    this.PhoneNumber = '';
    this.PhoneNumber2 = '';
    this.State = '';
    this.Street1 = '';
    this.Street2 = '';
    this.Title = '';
    this.Description = '';
    this.Zip = '';
    this.ZoneId = -1;
    this.TetheredLocationFlag = false;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    this.UpdatedUTC = new Date();
    this.CreatedDateUTC = new Date();
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeAddress;
}